<template>
  <component
    :is="componentName"
    v-if="formFieldsData.memberValues.value[field.name]"
    v-model="formFieldsData.memberValues.value"
    :field="field"
  />
  <component
    :is="componentName"
    v-else
    :field="field"
    @loading="(value) => emit('loading', value)"
  />
</template>
<script setup lang="ts">
interface Props {
  field: FormField;
}

const props = defineProps({
  field: null
});

const emit = defineEmits(["loading"]);

const { formFieldsData } = inject(INJECT_FORM_PAGE);

const componentName = computed(() => {
  switch (props.field.type) {
    case 'phone':
      return resolveComponent('FormFieldPhone');
    case 'boolean':
      if (props.field.template === 'rgpd') {
        return resolveComponent('FormFieldBoolean');
      } else {
        return resolveComponent('FormFieldBooleanCheckBox');
      }
    case 'freelibrary':
      return resolveComponent('FormFieldFreeLibrary');
    case 'date':
      return resolveComponent('FormFieldDate');
    case 'email':
    case 'text':
    case 'number':
    case 'password':
      return resolveComponent('FormFieldText');
    case 'staticText':
      return resolveComponent('FormFieldStaticText');
    case 'referralCode':
      return resolveComponent('FormFieldReferalCode');
    case 'select':
      if (props.field.template === 'list') {
        return resolveComponent('FormFieldSelectList');
      } else if (!hasSubfields.value) {
        return resolveComponent('FormFieldSelectGrid');
      } else {
        return resolveComponent('FormFieldSelectSub');
      }
  }
});

const hasSubfields = computed<boolean>(() => {
  if (props.field.type !== 'select') return false;
  const hasSubfields =
    props.field.options.findIndex(
      (option) => typeof option.subfield !== 'undefined'
    ) > -1;
  return hasSubfields;
});

if (props.field.type === 'freelibrary') {
  // emit('locked', true);
}

onMounted(() => {
  if (
    typeof formFieldsData.memberValues?.value[props.field.name]?.value ===
    'string'
  ) {
    const val = toRaw(
      formFieldsData.memberValues.value[props.field.name].value
    );

    // FIX issue first time edit model.value not updated
    // TODO update vue and nuxt deps

    formFieldsData.memberValues.value[props.field.name].value = val + ' ';
    requestAnimationFrame(() => {
      formFieldsData.memberValues.value[props.field.name].value = val + '';
    });
  }
});
</script>
